import React, { useState } from 'react';
import ContactModal from '../components/ContactModal';

export default function Contact() {
  const [showForm, setShowForm] = useState(false);

  // Defining the URL inside the component to ensure it's in scope
  const whatsappUrl = 'https://api.whatsapp.com/send/?phone=919022040062&text=Hello%20i-Sha%20Infosys';

  const contactInfo = [
    {
      title: 'Office Address',
      text: 'C-89, Shanti Shopping Center, Opposite to Railway Station, Mira Road East - 401107',
      link: null
    },
    {
      title: 'Primary Phone',
      text: '+91 90220 40062',
      // Using the WhatsApp URL here
      link: whatsappUrl 
    },
    {
      title: 'Email Support',
      text: 'Support@ishainfosys.com',
      link: 'mailto:Support@ishainfosys.com'
    }
  ];

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero-inner">
          <span className="eyebrow">Contact</span>
          <h1>Start with a conversation about what your office needs next.</h1>
          <p>
            Whether you need faster support, a better setup, or a complete infrastructure refresh,
            we are ready to help.
          </p>
        </div>
      </section>

      <section className="container section">
        <div className="contact-layout">
          <div className="contact-copy">
            <div className="section-header section-header-left">
              <span className="eyebrow">Talk To Us</span>
              <h2>Reach us for urgent fixes, site planning, security upgrades, or long-term support.</h2>
              <p>
                We work with offices that want technology to feel cleaner, more dependable, and easier to maintain.
              </p>
            </div>

            <div className="contact-action-card">
              <h3>Choose the fastest way to connect</h3>
              <p>
                Use WhatsApp for quick responses or open the contact form if you want to describe your requirements in more detail.
              </p>
              <div className="contact-actions">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn">
                  WhatsApp Chat
                </a>
                <button className="btn btn-outline-accent" onClick={() => setShowForm(true)}>
                  Open Contact Form
                </button>
              </div>
              <div className="contact-meta">
                <span>Proprietor: Mohammed Yaseen Shaikh</span>
                <span>GSTIN: 27DFNPS5093L1ZH</span>
              </div>
            </div>
          </div>

          <div className="map-card">
            <iframe
              className="contact-map-frame"
              title="i-Sha Infosys Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.744158495034!2d72.8732!3d19.2847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b1fdb6d54ae3%3A0xe7a45637b194db98!2si-Sha%20Infosys!5e0!3m2!1sen!2sin!4v1234567890"
              //src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.744158495034!2d72.8732!3d19.2847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b066aaaaaaaaaa%3A0xaaaaaaaaaaaaaaaa!2sMira%20Road!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>
        </div>

        <div className="contact-card-grid contact-card-grid-wide">
          {contactInfo.map((item) => (
            <article key={item.title} className="contact-card">
              <h3>{item.title}</h3>
              {item.link ? (
                <a 
                  href={item.link} 
                  target={item.link.startsWith('http') ? "_blank" : "_self"} 
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <p>{item.text}</p>
                </a>
              ) : (
                <p>{item.text}</p>
              )}
            </article>
          ))}
        </div>
      </section>

      {showForm && <ContactModal onClose={() => setShowForm(false)} subject="General Inquiry" />}
    </>
  );
}